import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

import { CerFormView } from '@form/cer-form-view';

export class TeamForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 30);
    
    // Team
    const team = new CerFormView();
    team.paneTarget = 'main';
    team.viewMetadata = {
      name: 'team', dataApiName: 'Team', text: 'Teams', textSingular: 'Team',
      primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
    };
    team.fieldMetadata = [];
    viewSet.viewAdd(team);

    // Team member
    const member = new CerFormView();
    member.mandatory = true;
    member.viewMetadata = { name: 'team-medlem', dataApiName: 'TeamUser', text: 'Team medlemmer', textSingular: 'Team medlem',
       primaryKey: 'id', parentPrimaryKey: 'num', parentForeignKey: 'team', 
       baseFields: ['id', 'history'], titleFields: ['team'] };  
    member.fieldMetadata = [
      { name: 'team', text: 'Team', required: true, foreignKeyTableName: 'Team', foreignKeyField: 'num', visible: false, widthType: FieldWidthEnum.M },
      { name: 'user', text: 'Medlem', required: true, foreignKeyTableName: 'User', foreignKeyField: 'shortName', foreignKeyValue: 'shortName', widthType: FieldWidthEnum.S },  
      { name: 'isActive', text: 'Aktiv', defaultValue: 1, format: 'CheckBox', required: true, widthType: FieldWidthEnum.XXS  }
    ];

    viewSet.viewAdd(member, team);
  }
}
